import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import api, { formatApiError } from "@/lib/api";
import Logo from "@/components/Logo";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
    const { t } = useI18n();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try { await api.post("/auth/forgot-password", { email }); setSent(true); }
        catch { setSent(true); } finally { setLoading(false); }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-secondary/30 px-6">
            <div className="w-full max-w-md rounded-3xl border border-border/70 bg-card p-8">
                <div className="mb-8 flex items-center justify-between"><Logo /><LanguageSwitcher compact /></div>
                {sent ? (
                    <div className="text-center" data-testid="forgot-sent">
                        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-accent/12 text-accent"><MailCheck className="h-7 w-7" /></div>
                        <h1 className="mt-4 font-serif text-2xl font-bold">{t("auth.linkSent")}</h1>
                        <p className="mt-2 text-sm text-muted-foreground">{t("auth.linkSentSub")}</p>
                        <Link to="/login"><Button variant="outline" className="mt-6 rounded-full"><ArrowLeft className="mr-1 h-4 w-4" />{t("auth.backToLogin")}</Button></Link>
                    </div>
                ) : (
                    <>
                        <h1 className="font-serif text-2xl font-bold">{t("auth.forgotTitle")}</h1>
                        <p className="mt-2 text-sm text-muted-foreground">{t("auth.forgotSub")}</p>
                        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
                            <div><Label>{t("common.email")}</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="mt-1.5" /></div>
                            <Button type="submit" disabled={loading} className="w-full rounded-full" data-testid="forgot-submit">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : t("auth.sendLink")}</Button>
                        </form>
                        <Link to="/login" className="mt-6 inline-flex items-center text-sm text-muted-foreground hover:text-foreground"><ArrowLeft className="mr-1 h-4 w-4" />{t("auth.backToLogin")}</Link>
                    </>
                )}
            </div>
        </div>
    );
}
